var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"display":"block","width":"100%"},attrs:{"src":"https://cdn.keihong.tech/img/202403201027675.png"}})])
}]

export { render, staticRenderFns }